module.exports = __webpack_public_path__ + "img/signup-bg.130003ed.svg";